import type { Formation } from '@pn/core/domain/helper-data/formation';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type FormationsStorageState = {
  isFetching: boolean;
  isError: boolean;
  formations: Formation[];
  shouldLoad: boolean;
};

const initialState: FormationsStorageState = {
  isFetching: false,
  isError: false,
  formations: [],
  shouldLoad: true,
};

const createFormationsSlice = (sliceName: string) =>
  createSlice({
    name: sliceName,
    initialState,
    reducers: {
      request: (state) => {
        state.isFetching = true;
        state.shouldLoad = false;
      },
      receive: (state, action: PayloadAction<Formation[]>) => {
        state.formations = action.payload;
        state.isFetching = false;
      },
      error: (state) => {
        state.isFetching = false;
        state.isError = true;
      },
    },
  });

export const formationsSlice = createFormationsSlice('formations');
